/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventModalViewedFromJSON(json) {
    return StreemApiAnalyticEventModalViewedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventModalViewedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'modalId': !exists(json, 'modal_id') ? undefined : json['modal_id'],
    };
}
export function StreemApiAnalyticEventModalViewedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'modal_id': value.modalId,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventModalViewed.js.map